export { WelcomeDetail, WelcomeDetailEditable } from './WelcomeDetail';
